module.exports = __webpack_public_path__ + "img/symbol_12.5eeca12b.png";